import { gql } from '~gql-types/gql'

export const FETCH_SHARE_LINK_TOKEN_DETAILS = gql(`
  query fetchShareLinkTokenDetails($boardId: ID!, $tokenId: ID!) {
    loggedInUser {
      id
      firstname
      lastname
      username
      legacyEid
      profilePhotoUrl
      isBoardFollower(boardId: $boardId)
      isShareLinkVisitor(tokenId: $tokenId)
      isShareLinkRegistrant(tokenId: $tokenId)
    }
  }
`)

export const ADD_SHARE_LINK_VISITORS = gql(`
  mutation AddShareLinkVisitors($boardId: ID!, $tokenId: ID!) {
    addShareLinkVisitors(boardId: $boardId, tokenId: $tokenId) {
      id
    }
  }
`)

export const JOIN_BOARD_WITH_TOKEN = gql(`
  mutation JoinBoardWithToken($boardId: ID!, $tokenId: ID!) {
    joinBoardWithToken(boardId: $boardId, tokenId: $tokenId) {
      id
    }
  }
`)
